module.exports = __webpack_public_path__ + "img/cocobank-logo.9ec984f8.svg";